import React from 'react'
import {
  FieldErrors,
  UseFormRegister,
  UseFormSetValue,
  UseFormWatch,
  Controller,
  Control,
} from 'react-hook-form'
import CheckIcon from '../../../../images/check_icon.png'
import { TextInput } from '../../../../components/form/inputs/TextInput'
import { QuillEditor } from '../../../../components/form/inputs/QuillEditor'
import { FormField } from '../../../../components/form'
import { FormErrorMessage } from '../../../../constants/message'
import { CoCreationTabData, EditFormData } from '../types'

// フォーム専用の型定義

interface CoCreationEditTabProps {
  watch: UseFormWatch<EditFormData>
  setValue: UseFormSetValue<EditFormData>
  register: UseFormRegister<EditFormData>
  errors: FieldErrors<EditFormData>
  control: Control<EditFormData>
}

const CoCreationEditTab: React.FC<CoCreationEditTabProps> = ({
  watch,
  setValue,
  register,
  errors,
  control,
}) => {
  const formData = watch()

  const handleQuillChange = (field: keyof CoCreationTabData, value: string) => {
    setValue(`coCreation.${field}`, value)
  }

  return (
    <div>
      <div className="py-6">
        <FormField
          label="タイトル"
          labelClassName="text-xl font-bold mb-3"
          showTag={false}
          error={errors.coCreation?.title?.message}
        >
          <TextInput
            register={register('coCreation.title', {
              maxLength: {
                value: 250,
                message: FormErrorMessage.maxLength(250),
              },
            })}
            placeholder="タイトルを入力してください"
          />
        </FormField>
        <FormField
          label="内容"
          labelClassName="text-xl font-bold mb-3"
          showTag={false}
          error={errors.coCreation?.content?.message}
        >
          <Controller
            control={control}
            name="coCreation.content"
            rules={{
              maxLength: {
                value: 30000,
                message: FormErrorMessage.maxLength(30000),
              },
            }}
            render={({ field }) => (
              <QuillEditor
                value={field.value || ''}
                onChange={(value) => {
                  field.onChange(value)
                  handleQuillChange('content', value)
                }}
                placeholder="内容を入力してください"
              />
            )}
          />
        </FormField>
      </div>

      {/* 区切り線 */}
      <div className="border-b border-black mb-6"></div>

      {/* 解決したい課題 */}
      <div className="pb-6">
        <FormField
          label="解決したい課題"
          labelClassName="text-xl font-bold mb-3"
          showTag={false}
          error={errors.coCreation?.issue?.message}
        >
          <Controller
            control={control}
            name="coCreation.issue"
            rules={{
              maxLength: {
                value: 30000,
                message: FormErrorMessage.maxLength(30000),
              },
            }}
            render={({ field }) => (
              <QuillEditor
                value={field.value || ''}
                onChange={(value) => {
                  field.onChange(value)
                  handleQuillChange('issue', value)
                }}
                placeholder="解決したい課題を入力してください"
              />
            )}
          />
        </FormField>
      </div>

      {/* 区切り線 */}
      <div className="border-b border-black mb-6"></div>

      {/* 共創で実現したいこと */}
      <div className="pb-6">
        <FormField
          label="共創で実現したいこと"
          labelClassName="text-xl font-bold mb-3"
          showTag={false}
          error={errors.coCreation?.goal?.message}
        >
          <Controller
            control={control}
            name="coCreation.goal"
            rules={{
              maxLength: {
                value: 30000,
                message: FormErrorMessage.maxLength(30000),
              },
            }}
            render={({ field }) => (
              <QuillEditor
                value={field.value || ''}
                onChange={(value) => {
                  field.onChange(value)
                  handleQuillChange('goal', value)
                }}
                placeholder="共創で実現したいことを入力してください"
              />
            )}
          />
        </FormField>
      </div>

      {/* 区切り線 */}
      <div className="border-b border-black mb-6"></div>

      {/* 求めている条件 */}
      <div className="pb-6">
        <div className="flex items-center">
          <img src={CheckIcon} alt="Check" className="w-7 h-7 mr-2" />
          <h3 className="text-xl font-bold text-main-black">求めている条件</h3>
        </div>
        <FormField
          label=""
          labelClassName="text-xl font-bold mb-3"
          showTag={false}
          error={errors.coCreation?.requirement?.message}
        >
          <Controller
            control={control}
            name="coCreation.requirement"
            rules={{
              maxLength: {
                value: 30000,
                message: FormErrorMessage.maxLength(30000),
              },
            }}
            render={({ field }) => (
              <QuillEditor
                value={field.value || ''}
                onChange={(value) => {
                  field.onChange(value)
                  handleQuillChange('requirement', value)
                }}
                placeholder="求めている条件を入力してください"
              />
            )}
          />
        </FormField>
      </div>
    </div>
  )
}

export default CoCreationEditTab
